<template>
  <BaseTypeIndexShell base-type="accommodations">
    <ContractContingent objectType="accommodations" :activeObjectCount="activeMarketingObjects" />
    <ObjectsTable :objects="objects" base-type="accommodations" :show-stats-action="true" />
  </BaseTypeIndexShell>
</template>

<script>
import ObjectsTable from "@/components/objects/ObjectsTable.vue";
import {useObjectStore} from "@/stores/object";
import ContractContingent from "@/components/objects/ContractContingent.vue";
import BaseTypeIndexShell from "@/components/base_type/BaseTypeIndexShell.vue";

export default {
  components: {
    BaseTypeIndexShell,
    ContractContingent,
    ObjectsTable,
  },
  data() {
    return {
      objects: [],
    }
  },
  setup() {
    return {
      objectStore: useObjectStore(),
    }
  },
  created() {
    this.objectStore.apiIndex(this.$route.meta.base_type).then(({data}) => {
      this.objects = this.normalizeObjects(data)
    })
  },
  methods: {
    normalizeObjects(data) {
      return Array.isArray(data) ? data : data?.objects || []
    },
  },
  computed: {
    activeMarketingObjects() {
      return this.normalizeObjects(this.objects).filter(o => o.setting_enable_in_manet_stadt_abl === true).length
    },
  },
}
</script>
